import React, { lazy, Suspense } from 'react'

const LazyLabels = lazy(() => import(/* webpackChunkName: "labels" */ './LabelFinder'))

const Labels = props => (
  <Suspense fallback={null}>
    <LazyLabels {...props} />
  </Suspense>
)

export { Labels, Labels as default }
